module.exports = __webpack_public_path__ + "img/txt.25b90630.png";